import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["align", "theme"];
import React from 'react';
import { deprecatedPropWarning } from "../../deprecationWarnings";
import { TableCellElement } from "./TableCell";
export var TableCell = function TableCell(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'start' : _ref$align,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  if (theme) {
    deprecatedPropWarning('theme', 'This component is intended to inherit its parent’s color set or color.');
  }

  return /*#__PURE__*/React.createElement(TableCellElement, Object.assign({
    align: align
  }, props));
};
/**
* **TableCell** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TableCell) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-table-tablecell--highlight) | [Encore](https://encore.spotify.net/web/components/table?format=figma-figma#cell) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=525:1495) |
*
* Cells are the most basic unit of a table. They are contained within rows and influenced by other cells in the same column.
*
* @example
* () => (
*  <Table>
*    <tbody>
*      <TableRow>
*        <TableCell as="th" scope="row" highlight>
*          Highlight
*        </TableCell>
*        <TableCell>Default</TableCell>
*        <TableCell>Default</TableCell>
*      </TableRow>
*    </tbody>
*  </Table>
*);
*
*/

export default TableCell;